// ButtonCareer.js

import React, { useState } from 'react';

export const ButtonCareer = ({ name, onClick, isSelected }) => {
  return (
    <button
      className={isSelected ? 'btn-career-selected' : 'btn-career'}
      onClick={onClick}
    >
      {name}
    </button>
  );
};
